/** Registry of storefront legal / policy pages editable in backoffice. */

export const LEGAL_PAGES = [
  { slug: "terms", settingKey: "legal.terms", title: "Terms & Conditions" },
  { slug: "privacy", settingKey: "legal.privacy", title: "Privacy Policy" },
  { slug: "refund", settingKey: "legal.refund", title: "Refund Policy" },
  { slug: "shipping", settingKey: "legal.shipping", title: "Shipping Policy" },
] as const;

export type LegalPageSlug = (typeof LEGAL_PAGES)[number]["slug"];

const SLUG_INDEX = Object.fromEntries(LEGAL_PAGES.map((p) => [p.slug, p])) as Record<
  LegalPageSlug,
  (typeof LEGAL_PAGES)[number]
>;

const KEY_INDEX = Object.fromEntries(LEGAL_PAGES.map((p) => [p.settingKey, p])) as Record<
  string,
  (typeof LEGAL_PAGES)[number]
>;

export function isLegalSlug(slug: string): slug is LegalPageSlug {
  return slug in SLUG_INDEX;
}

export function legalPageBySlug(slug: string): (typeof LEGAL_PAGES)[number] | undefined {
  return isLegalSlug(slug) ? SLUG_INDEX[slug] : undefined;
}

export function legalSettingKey(slug: LegalPageSlug): string {
  return SLUG_INDEX[slug].settingKey;
}

export function legalPageTitle(slug: LegalPageSlug): string {
  return SLUG_INDEX[slug].title;
}

export function legalPageBySettingKey(key: string): (typeof LEGAL_PAGES)[number] | undefined {
  return KEY_INDEX[key];
}
